import { Image, Link } from "@chakra-ui/react"

type FooterSocialLinkProps = {
  href: string
  icon: string
}

export default function FooterSocialLink({
  href,
  icon,
}: FooterSocialLinkProps) {
  return (
    <Link href={href} target="_blank">
      <Image src={icon} />
    </Link>
  )
}
